__turbopack_context__.v({
  "action-complete": "PremiumOnboarding-module-scss-module__OG3k7q__action-complete",
  "addon-description": "PremiumOnboarding-module-scss-module__OG3k7q__addon-description",
  "check-icon": "PremiumOnboarding-module-scss-module__OG3k7q__check-icon",
  "content": "PremiumOnboarding-module-scss-module__OG3k7q__content",
  "controls": "PremiumOnboarding-module-scss-module__OG3k7q__controls",
  "customizable-part": "PremiumOnboarding-module-scss-module__OG3k7q__customizable-part",
  "description": "PremiumOnboarding-module-scss-module__OG3k7q__description",
  "description-bolded-headline": "PremiumOnboarding-module-scss-module__OG3k7q__description-bolded-headline",
  "description-caption": "PremiumOnboarding-module-scss-module__OG3k7q__description-caption",
  "domain": "PremiumOnboarding-module-scss-module__OG3k7q__domain",
  "domain-example": "PremiumOnboarding-module-scss-module__OG3k7q__domain-example",
  "feature-item-list": "PremiumOnboarding-module-scss-module__OG3k7q__feature-item-list",
  "get-addon-button": "PremiumOnboarding-module-scss-module__OG3k7q__get-addon-button",
  "go-to-dashboard-button": "PremiumOnboarding-module-scss-module__OG3k7q__go-to-dashboard-button",
  "is-completed": "PremiumOnboarding-module-scss-module__OG3k7q__is-completed",
  "label": "PremiumOnboarding-module-scss-module__OG3k7q__label",
  "lead": "PremiumOnboarding-module-scss-module__OG3k7q__lead",
  "onboarding": "PremiumOnboarding-module-scss-module__OG3k7q__onboarding",
  "reply-description": "PremiumOnboarding-module-scss-module__OG3k7q__reply-description",
  "skip-link": "PremiumOnboarding-module-scss-module__OG3k7q__skip-link",
  "step": "PremiumOnboarding-module-scss-module__OG3k7q__step",
  "step-addon": "PremiumOnboarding-module-scss-module__OG3k7q__step-addon",
  "step-custom-domain": "PremiumOnboarding-module-scss-module__OG3k7q__step-custom-domain",
  "styled-progress-bar": "PremiumOnboarding-module-scss-module__OG3k7q__styled-progress-bar",
  "subdomain-picker-heading": "PremiumOnboarding-module-scss-module__OG3k7q__subdomain-picker-heading",
  "title-container": "PremiumOnboarding-module-scss-module__OG3k7q__title-container",
});
